<template>
  <div class="online-courses-page">
    <div class="heading">
      <h1>Privacy Policy</h1>
    </div>
    <div class="privacy-container">
      <h1 class="title">Azadi Academy Privacy Policy</h1>
      <p class="effective-date">Effective Date: January 26th, 2025</p>

      <section>
        <h2>1. Information We Collect</h2>
        <p>We may collect the following types of information:</p>
        <ul>
          <li>Name</li>
          <li>Email address</li>
          <li>Phone number</li>
          <li>Country</li>
          <li>Payment details (for paid courses)</li>
        </ul>
      </section>

      <section>
        <h2>2. How We Use Your Information</h2>
        <p>We use your information for the following purposes:</p>
        <ul>
          <li>To provide and improve our courses and services.</li>
          <li>
            To communicate updates, promotional offers, and relevant content.
          </li>
          <li>To process payments and manage enrollments.</li>
          <li>
            To enhance user experience through analytics and performance
            tracking.
          </li>
          <li>To ensure security and prevent unauthorized access.</li>
        </ul>
      </section>

      <section>
        <h2>3. Sharing Your Information</h2>
        <p>
          We do not sell, rent, or trade your personal information. However, we
          may share your information in the following cases:
        </p>
        <ul>
          <li>
            With service providers (e.g., payment processors) to facilitate our
            services.
          </li>
          <li>If required by law or to protect our legal rights.</li>
          <li>
            In the event of a merger, acquisition, or transfer of assets, where
            your information may be part of the transaction.
          </li>
        </ul>
      </section>

      <section>
        <h2>4. Data Storage and Security</h2>
        <p>
          We take appropriate technical and organizational measures to protect
          your data from unauthorized access, alteration, disclosure, or
          destruction. These include:
        </p>
        <ul>
          <li>Secure servers and encryption.</li>
          <li>Regular system monitoring and audits.</li>
          <li>Limited access to personal data by authorized personnel only.</li>
        </ul>
      </section>

      <section>
        <h2>5. Your Rights</h2>
        <p>As a user, you have the following rights:</p>
        <ul>
          <li>
            <strong>Correction:</strong> Request corrections to any inaccurate
            or incomplete information.
          </li>
          <li>
            <strong>Deletion:</strong> Request the deletion of your personal
            information.
          </li>
          <li>
            <strong>Withdrawal of Consent:</strong> Opt out of receiving
            marketing emails or revoke previously given consent.
          </li>
        </ul>
        <p>
          To exercise these rights, contact us at
          <a href="mailto:info@azadicoin.com">info@azadicoin.com</a>
        </p>
      </section>

      <section>
        <h2>6. Cookies and Tracking Technologies</h2>
        <p>
          Azadi Academy uses cookies to enhance user experience and gather
          website analytics. You can manage cookie preferences through your
          browser settings.
        </p>
      </section>

      <section>
        <h2>7. Third-Party Links</h2>
        <p>
          Our website may contain links to third-party websites. We are not
          responsible for the privacy practices or content of these external
          sites. Please review their privacy policies before sharing your
          information.
        </p>
      </section>

      <section>
        <h2>8. Changes to This Privacy Policy</h2>
        <p>
          Azadi Academy reserves the right to update this Privacy Policy at any
          time. Significant changes will be communicated via email or
          announcements on our website. The updated policy will include the
          "Effective Date" at the top.
        </p>
      </section>

      <section>
        <h2>9. Contact Us</h2>
        <p>
          For questions or concerns regarding this Privacy Policy, please
          contact us at:
          <a href="mailto:info@azadicoin.com">info@azadicoin.com</a>
        </p>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: "PrivacyPolicyPage",
};
</script>

<style scoped>
.privacy-container {
  padding: 2rem;
  max-width: 65rem;
  margin: 0 auto;
  background-color: #0e1332;
  border-radius: 1rem;
  font-family: 'Gothic';
  color: #fff;
}

.title {
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 1rem;
  font-family: 'GothicB';
}

.effective-date {
  font-style: italic;
  margin-bottom: 1rem;
}

section {
  margin-bottom: 1.5rem;
}

h2 {
  font-size: 1.25rem;
  font-weight: bold;
  margin-bottom: 0.5rem;
  font-family: 'GothicB';
}

p {
  line-height: 1.6;
}

ul {
  list-style-type: disc;
  margin-left: 1.5rem;
}

ul li {
  margin-bottom: 0.5rem;
}

a {
  color: #007bff;
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

.heading {
  background-color: #0e1332;
}
.heading h1 {
  padding: 3rem 1.5rem;
  max-width: 65rem;
  margin: 0 auto 2rem;
  color: #fff;
  text-align: center;
  font-family: 'GothicB';
  line-height: 4rem;
}
</style>
